<template>
    <mdb-container>
        <Vedheader></Vedheader>
        <Adminheader></Adminheader>
        <section class="mt-3">
            <mdb-row>
                <mdb-col>
                    <h2>Utilisateurs</h2>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <!--Grid column-->
                <mdb-col xl="12" md="12">
                    <mdb-input class="mt-0" v-model="search" label="Recherche" />
                    <mdb-datatable-2 class="cursor" v-model="users" v-if="users.rows.length" :searching="{value: search, field: 'firstname,lastname,email'}" @selected="loadUserDetails($event)"  />
                </mdb-col>

            </mdb-row>
        </section>
        <mdb-footer color="mdb-color" class="font-small lighten-3 pt-4 mt-4 mt-5">
            <div class="footer-copyright text-center py-3">
                <mdb-container fluid>
                    &copy; 2020 Copyright: <a href="https://expertenvoyages.com/"> Expert En Voyage </a>
                </mdb-container>
            </div>
        </mdb-footer>
    </mdb-container>
</template>
<script>
    import Vedheader from '@/components/Header.vue';
    import Adminheader from '@/components/Adminheader.vue';
    import {
        mdbContainer,
        mdbFooter,
        mdbCol,
        mdbRow,
        // mdbBtn,
        mdbDatatable2,
        mdbInput,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'Adminusers',
        components: {
            Vedheader,
            mdbContainer,
            mdbFooter,
            mdbCol,
            mdbRow,
            Adminheader,
           // mdbBtn,
            mdbDatatable2,
            mdbInput,
        },
        data() {
            return {
                search: '',
                users: {
                    columns: [
                        {
                            label: 'Prénom',
                            field: 'firstname',
                            sort: true,
                        },
                        {
                            label: 'Nom',
                            field: 'lastname',
                            sort: true,
                        },
                        {
                            label: 'Courriel',
                            field: 'email',
                            sort: true,
                        },
                        {
                            label: 'Agence',
                            field: 'agency',
                            sort: true,
                        },
                    ],
                    rows: [
                    ],
                },
                isLoading: true,
                selecteduser: null,
                nbusers: 0,
            };
        },
        mounted() {
            this.getAndDisplayAllUsers();
        },
        methods: {
            getAndDisplayAllUsers() {
                const api = new Apicall();
                const self = this;
                api.getUsers().then((response) => {
                    if (response.status === 'OK') {
                        self.users.rows = response.users;
                        console.log(self.users);
                    }
                });
            },
            loadUserDetails(u) {
                this.$router.push({ name: 'UserDetails', params: { usersystemid: u.systemid } });
            },
        },
    };
</script>

<style scoped>
    .cursor{
        cursor: pointer;
    }
</style>
